/**
 * Custom hook untuk mengambil detail maintenance
 * 
 * API Endpoint: GET `/api/room-maintenance/:id`
 * API Version: 3.0
 * 
 * @param {string} id - ID room maintenance
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 * @example
 * const { data, isLoading, error } = useShowBank({ id: '1' });
 */


import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ShowRoomMaintenanceResponse } from "../response/ShowRoomMaintenanceResponse";

interface ShowRoomMaintenanceProps {
    id?: string;
    include?: string;
}

const useShowRoomMaintenance = ({ id, include }: ShowRoomMaintenanceProps) => {
    const params = {
        include: include,
    }

    return useQuery({
        queryKey: ['room-maintenance', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/room-maintenance/${id}`, { params });

                // Validasi response
                const validationResult = ShowRoomMaintenanceResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid room maintenance data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch room maintenance`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowRoomMaintenance;